import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme, Typography } from '@material-ui/core'
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined'
import ConfirmationDialog from 'components/ConfirmationDialog/ConfirmationDialog'
import {
    CANCEL_TEXT,
    CONTINUE_TEXT,
    REMOVE_MS_TEXT,
} from 'pages/components/constants'
import React, { useMemo } from 'react'
interface RemoveMasterSpecWarningProps {
    open: boolean
    onSubmit: () => void
    onCancel: () => void
}

const useStyles = makeStyles((theme: Theme) => ({
    dialogTitleContainer: {
        alignItems: 'center',
    },
    warningIcon: {
        fontSize: pxToRem(34),
        fill: '#F0451F',
    },
    titleText: {
        marginLeft: theme.spacing(1.5),
        color: '#304959',
        fontSize: pxToRem(34),
    },
    warningText: {
        color: '#3C3C3C',
        fontSize: pxToRem(14),
        fontWeight: 400,
        maxWidth: pxToRem(560),
        lineHeight: pxToRem(18),
        marginRight: pxToRem(8),
        whiteSpace: 'pre-line',
    },
}))

export const RemoveMasterSpecWarning = ({
    open,
    onSubmit,
    onCancel,
}: RemoveMasterSpecWarningProps) => {
    const classes = useStyles()

    const dialogHeading = useMemo(
        () => (
            <>
                <GridContainer
                    className={classes.dialogTitleContainer}
                    data-testid="cautionRemoveMasterSpecHeader"
                >
                    <ReportProblemOutlinedIcon
                        data-testid="warningRemoveMasterSpecIcon"
                        className={classes.warningIcon}
                    />
                    <Typography className={classes.titleText} component="span">
                        Caution
                    </Typography>
                </GridContainer>
            </>
        ),
        []
    )

    const mainContent = useMemo(
        () => (
            <Typography
                className={classes.warningText}
                component="div"
                data-testid="warningRemoveMasterSpecText"
            >
                {REMOVE_MS_TEXT}
            </Typography>
        ),
        []
    )

    return (
        <ConfirmationDialog
            dialogHeading={dialogHeading}
            openDialog={open}
            handleDialogClose={onCancel}
            dialogActionCallback={onSubmit}
            contentNode={mainContent}
            contentOverflow
            size="default"
            cancelText={CANCEL_TEXT}
            confirmText={CONTINUE_TEXT}
            confirmMessage=" "
            variant="default"
            contentStyles={{
                padding: 0,
                borderTop: 'none',
                borderBottom: 'none',
                width: 'auto',
            }}
        />
    )
}

export default RemoveMasterSpecWarning
